import { GenericService } from '../GenericService'

class CompanyService extends GenericService {
    constructor() {
        super('/api/admin/company')
    }

    getSingleRecord = (id) => this.get('/api/admin/company/getSingle/' + id)
    multipleDelete = (data) =>
        this.post('/api/admin/company/multipleDelete', data)
}

export default new CompanyService()
